var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zoom-on-hover",class:{ zoomed: _vm.zoomed },on:{"mousemove":_vm.move,"mouseenter":_vm.zoom,"mouseleave":_vm.unzoom}},[_c('img',{ref:"def",staticClass:"def",attrs:{"src":_vm.imgDef}}),_c('img',{ref:"zoom",staticClass:"zoom",attrs:{"src":_vm.imgZoom || _vm.imgDef}})])
}
var staticRenderFns = []

export { render, staticRenderFns }